export const camelCaseToDash = string => string.toString().replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
export const dashToCamelCase = string => string.toString().replace(/-([a-z])/g, g => g[1].toUpperCase());
export const spacesToUnderscores = string => string.toString().split(' ').join('_');

// Returns an object with keys and values equal to the items of the provided array
export const objectKeyMirror = arr =>
  arr.reduce((mirroredObject, key) => {
    mirroredObject[key] = `${key}`;
    return mirroredObject;
  }, {});

// Curried version - splits array into chunks of given size
export const chunkArray = chunkSize => array =>
  array.reduce((acc, _, index, src) =>
    !(index % chunkSize) ? [...acc, src.slice(index, index + chunkSize)] : acc,
  []);

export const removeLeadingZeros = string => string.replace(/^0+/, '');

export const flattenArray = (array, depth = 1) =>
  array.reduce((flat, toFlatten) =>
    flat.concat((Array.isArray(toFlatten) && (depth > 1)) ? toFlatten.flat(depth-1) : toFlatten), []);

export const sanitizeString = string => string.toString().replace(/([^a-z0-9_]+)/gi, '');

export const isFilterOff = filter => !Object.values(filter).some(v => {
  if (Array.isArray(v)) {
    return v.length;
  } else if (typeof v === 'object' && v !== null) {
    return Object.values(v).some(status => status)
  } else {
    return v;
  }
})



// WEBPACK FOOTER //
// ./src/utils/utils.js